import React from 'react';
import {Redirect, Route} from 'react-router';

export default function PrivateRoute({children, ...rest}) {
    return (
        <Route
            {...rest}
            render={({location}) =>
                children.props.auth.isAuthenticated ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: '/',
                            state: {from: location}
                        }}
                    />)
            }
        />
    );
}
